'use client';

import { useAdminView } from '@/components/providers/AdminViewProvider';
import { Shield } from 'lucide-react';

export default function AdminViewBanner() {
  const { isAdminViewEnabled } = useAdminView();

  if (!isAdminViewEnabled) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white px-4 py-2 shadow-lg">
      <div className="container mx-auto flex items-center justify-center space-x-2">
        <Shield className="w-5 h-5" />
        <span className="font-semibold text-sm">
          ADMIN VIEW ENABLED. You are viewing restricted content.
        </span>
      </div>
    </div>
  );
}

